export const StockType = [
    { label: 'Produs', value: 'Produs' },
    { label: 'Carte', value: 'Carte' },
    { label: 'Overhead', value: 'Overhead' },
    { label: 'Altul', value: 'Altul'}
]